import { type FormInstance, type Rule } from "antd/lib/form"
import { checkDueInDays, checkMaxNumber, checkMinNumber } from "~Components/forms/rules/utils.rules"

export const createPossibleMatchesFilterRules = (formInstance: FormInstance) => ({
    minAmount: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxAmount" }),
        },
    ] as Array<Rule>,
    maxAmount: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minAmount" }),
        },
    ] as Array<Rule>,
    minProbability: [
        {
            validator: (_rule, value: number | string) =>
                checkMinNumber({
                    formInstance,
                    value,
                    name: "maxProbability",
                    minText: "input:filter_form.min_probability",
                    maxText: "input:filter_form.max_probability",
                    limit: 100,
                }),
        },
    ] as Array<Rule>,
    maxProbability: [
        {
            validator: (_rule, value: number | string) =>
                checkMaxNumber({
                    formInstance,
                    value,
                    name: "minProbability",
                    minText: "input:filter_form.min_probability",
                    maxText: "input:filter_form.max_probability",
                    limit: 100,
                }),
        },
    ] as Array<Rule>,
    dueInDays: [
        {
            validator: (_rule, value: number | string) => checkDueInDays(value),
        },
    ] as Array<Rule>,
})
